var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v("\n  " + _vm._s(_vm.engineerFilter) + "\n  "),
      _c(
        "modal",
        {
          attrs: { title: "Confirm ?" },
          model: {
            value: _vm.openAcceptProject,
            callback: function($$v) {
              _vm.openAcceptProject = $$v
            },
            expression: "openAcceptProject"
          }
        },
        [
          _c("p", { attrs: { slot: "content" }, slot: "content" }, [
            _vm._v("Accept Project")
          ]),
          _c("isButton", {
            attrs: {
              slot: "action",
              onClick: _vm.accept,
              state: "true",
              title: "Accept"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c(
        "modal",
        {
          attrs: { title: "Confirm ? " },
          model: {
            value: _vm.openActKnowledge,
            callback: function($$v) {
              _vm.openActKnowledge = $$v
            },
            expression: "openActKnowledge"
          }
        },
        [
          _c("p", { attrs: { slot: "content" }, slot: "content" }, [
            _vm._v("Acknowledge this project")
          ]),
          _c("isButton", {
            ref: "btnAct",
            attrs: {
              slot: "action",
              onClick: _vm.acknowledge,
              state: "true",
              title: "Acknowledge"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c(
        "modal",
        {
          attrs: { title: "Reset Quotation ? " },
          model: {
            value: _vm.openResetQuotation,
            callback: function($$v) {
              _vm.openResetQuotation = $$v
            },
            expression: "openResetQuotation"
          }
        },
        [
          _c("p", { attrs: { slot: "content" }, slot: "content" }, [
            _vm._v("Confirm to reset quotation")
          ]),
          _c("isButton", {
            ref: "btnResetQuotation",
            attrs: {
              slot: "action",
              onClick: _vm.confirmResetQuotation,
              state: "true",
              title: "Confirm"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c(
        "modal",
        {
          attrs: { title: "Accept Quotation ? " },
          model: {
            value: _vm.openAcceptQuotation,
            callback: function($$v) {
              _vm.openAcceptQuotation = $$v
            },
            expression: "openAcceptQuotation"
          }
        },
        [
          _c("p", { attrs: { slot: "content" }, slot: "content" }, [
            _vm._v("Accept quotation instead of customer")
          ]),
          _c("isButton", {
            ref: "btnAcceptQuotation",
            attrs: {
              slot: "action",
              onClick: _vm.confirmAcceptQuotation,
              state: "true",
              title: "Confirm"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c(
        "modal",
        {
          attrs: { title: "Select Member" },
          model: {
            value: _vm.openEngineer,
            callback: function($$v) {
              _vm.openEngineer = $$v
            },
            expression: "openEngineer"
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c("article", { staticClass: "message is-link" }, [
                _c("div", { staticClass: "message-header" }, [
                  _c("p", [_vm._v("Selected")])
                ]),
                _c("div", { staticClass: "message-body" }, [
                  _c("table", { staticClass: "table" }, [
                    _c(
                      "tbody",
                      _vm._l(_vm.listEngOfProject, function(item, index) {
                        return _c("tr", { key: item.userID }, [
                          _c("td", [
                            _c("input", {
                              attrs: { type: "checkbox", checked: "" },
                              on: {
                                click: function($event) {
                                  _vm.removeEng(index)
                                }
                              }
                            })
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(item.firstName) +
                                " " +
                                _vm._s(item.lastName) +
                                " "
                            ),
                            _c("span", { staticClass: "has-text-primary" }, [
                              _vm._v("  #" + _vm._s(item.role))
                            ])
                          ])
                        ])
                      })
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "columns " }, [
                _c("div", { staticClass: "column is-12" }, [
                  _c("div", { staticClass: "field" }, [
                    _c(
                      "p",
                      { staticClass: "control has-icons-left has-icons-right" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchText,
                              expression: "searchText"
                            }
                          ],
                          staticClass: "input is-rounded",
                          attrs: { type: "text", placeholder: "find member" },
                          domProps: { value: _vm.searchText },
                          on: {
                            keyup: _vm.searchEngineer,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.searchText = $event.target.value
                            }
                          }
                        }),
                        _c("span", { staticClass: "icon is-small is-left" }, [
                          _c("i", { staticClass: "fa fa-search" })
                        ])
                      ]
                    )
                  ])
                ])
              ]),
              _vm._l(_vm.filterEngineer, function(item, index) {
                return _c("div", { key: item.id, staticClass: "columns" }, [
                  _c("div", { staticClass: "column is-12" }, [
                    _c("label", { staticClass: "checkbox" }, [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        on: {
                          click: function($event) {
                            _vm.addEng(index)
                          }
                        }
                      })
                    ]),
                    _vm._v(
                      "\n          " +
                        _vm._s(item.firstName) +
                        " " +
                        _vm._s(item.lastName) +
                        "\n          "
                    ),
                    _c("span", { staticClass: "has-text-info" }, [
                      _vm._v("  #" + _vm._s(item.role))
                    ])
                  ])
                ])
              })
            ],
            2
          ),
          _c(
            "button",
            {
              staticClass: "button is-success",
              attrs: { slot: "action" },
              on: { click: _vm.showEngineers },
              slot: "action"
            },
            [_vm._v("Close")]
          )
        ]
      ),
      _c(
        "modal",
        {
          attrs: { title: "Assign Job Number" },
          model: {
            value: _vm.openAssignJob,
            callback: function($$v) {
              _vm.openAssignJob = $$v
            },
            expression: "openAssignJob"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "field",
              attrs: { slot: "content" },
              slot: "content"
            },
            [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.jobNumber,
                      expression: "jobNumber"
                    }
                  ],
                  staticClass: "input",
                  attrs: { type: "text", placeholder: "Assign Job Number" },
                  domProps: { value: _vm.jobNumber },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.jobNumber = $event.target.value
                    }
                  }
                })
              ])
            ]
          ),
          _c("isButton", {
            attrs: {
              slot: "action",
              onClick: _vm.assignJob,
              state: "true",
              title: "Save"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c(
        "modal",
        {
          attrs: { title: "Reminder" },
          model: {
            value: _vm.openReminder,
            callback: function($$v) {
              _vm.openReminder = $$v
            },
            expression: "openReminder"
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: { "min-height": "550px" },
              attrs: { slot: "content" },
              slot: "content"
            },
            [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Message")]),
                _c("div", { staticClass: "control" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.remind.remind,
                        expression: "remind.remind"
                      }
                    ],
                    staticClass: "textarea",
                    attrs: { placeholder: "Message" },
                    domProps: { value: _vm.remind.remind },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.remind, "remind", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Date")]),
                _c(
                  "div",
                  { staticClass: "control" },
                  [
                    _c("datepicker", {
                      attrs: {
                        inline: true,
                        "input-class": "input",
                        language: "en",
                        format: "dd/MM/yyyy"
                      },
                      model: {
                        value: _vm.remind.remindDate,
                        callback: function($$v) {
                          _vm.$set(_vm.remind, "remindDate", $$v)
                        },
                        expression: "remind.remindDate"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _c("isButton", {
            ref: "btnRemind",
            attrs: {
              slot: "action",
              onClick: _vm.remindProject,
              state: "true",
              title: "Save"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c(
        "modal",
        {
          attrs: { title: "Delete Project" },
          model: {
            value: _vm.openDelete,
            callback: function($$v) {
              _vm.openDelete = $$v
            },
            expression: "openDelete"
          }
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("div", [_vm._v("Would you like to delete this project ?")]),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.DeleteMessage,
                    expression: "DeleteMessage"
                  }
                ],
                staticClass: "input",
                attrs: { type: "text", placeholder: "Remark" },
                domProps: { value: _vm.DeleteMessage },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.DeleteMessage = $event.target.value
                  }
                }
              })
            ])
          ]),
          _c("isButton", {
            ref: "btnDelete",
            attrs: {
              slot: "action",
              onClick: _vm.deleteProject,
              state: "true",
              title: "Confirm Delete"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c(
        "modal",
        {
          attrs: { title: "Complete Project" },
          model: {
            value: _vm.openComplete,
            callback: function($$v) {
              _vm.openComplete = $$v
            },
            expression: "openComplete"
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: { "min-height": "550px" },
              attrs: { slot: "content" },
              slot: "content"
            },
            [
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column is-12" }, [
                  _c("b", [_vm._v("Invoice No")])
                ])
              ]),
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column is-12" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.completeInfo.invoiceNo,
                        expression: "completeInfo.invoiceNo"
                      }
                    ],
                    staticClass: "input",
                    attrs: { type: "text", placeholder: "InvoiceNo" },
                    domProps: { value: _vm.completeInfo.invoiceNo },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.completeInfo,
                          "invoiceNo",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column is-12" }, [
                  _c("b", [_vm._v("Invoice Date")])
                ])
              ]),
              _c("div", { staticClass: "columns" }, [
                _c(
                  "div",
                  { staticClass: "column is-12" },
                  [
                    _c("datepicker", {
                      attrs: {
                        inline: true,
                        "input-class": "input",
                        language: "en",
                        format: "dd/MM/yyyy"
                      },
                      model: {
                        value: _vm.completeInfo.invoiceDate,
                        callback: function($$v) {
                          _vm.$set(_vm.completeInfo, "invoiceDate", $$v)
                        },
                        expression: "completeInfo.invoiceDate"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _c("isButton", {
            ref: "btnComplete",
            attrs: {
              slot: "action",
              onClick: _vm.complete,
              state: "true",
              title: "Complete"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c(
        "modal",
        {
          attrs: { title: "Set Actual Task Date", isMaxSize: true },
          model: {
            value: _vm.openSetAct,
            callback: function($$v) {
              _vm.openSetAct = $$v
            },
            expression: "openSetAct"
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: { height: "500px" },
              attrs: { slot: "content" },
              slot: "content"
            },
            [
              _vm.lastQU !== null && _vm.lastQU.quotationTask.length > 0
                ? _c("table", { staticClass: "table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("TaskID")]),
                        _c("th", [_vm._v("Task Name")]),
                        _c("th", [_vm._v("Actual Start Date")]),
                        _c("th", [_vm._v("Actual Finish Date")])
                      ])
                    ]),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.lastQU.quotationTask, function(item) {
                          return _c("tr", { key: item.taskNo }, [
                            _c("td", [_vm._v(_vm._s(item.taskNo))]),
                            _c("td", [_vm._v(_vm._s(item.taskName))]),
                            _c(
                              "td",
                              [
                                _c("datepicker", {
                                  attrs: {
                                    "input-class": "input is-primary",
                                    language: "en",
                                    format: "dd/MM/yyyy",
                                    id: "actStatDate",
                                    name: "actStatDate"
                                  },
                                  model: {
                                    value: item.actStartDate,
                                    callback: function($$v) {
                                      _vm.$set(item, "actStartDate", $$v)
                                    },
                                    expression: "item.actStartDate"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                _c("datepicker", {
                                  attrs: {
                                    "input-class": "input is-primary",
                                    language: "en",
                                    format: "dd/MM/yyyy",
                                    id: "actFinishDate",
                                    name: "actFinishDate"
                                  },
                                  model: {
                                    value: item.actFinishDate,
                                    callback: function($$v) {
                                      _vm.$set(item, "actFinishDate", $$v)
                                    },
                                    expression: "item.actFinishDate"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        }),
                        _c("tr", [
                          _c("td", [_vm._v("Remark")]),
                          _c("td", { attrs: { colspan: "3" } }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.updateRemark,
                                  expression: "updateRemark"
                                }
                              ],
                              staticClass: "input",
                              attrs: { type: "text" },
                              domProps: { value: _vm.updateRemark },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.updateRemark = $event.target.value
                                }
                              }
                            })
                          ])
                        ])
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]
          ),
          _c("isButton", {
            ref: "btnSetActual",
            attrs: {
              slot: "action",
              onClick: _vm.saveActual,
              state: "true",
              title: "Save"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c(
        "modal",
        {
          attrs: { title: "Accept Production Task" },
          model: {
            value: _vm.openAcceptTask,
            callback: function($$v) {
              _vm.openAcceptTask = $$v
            },
            expression: "openAcceptTask"
          }
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("div", { staticClass: "media-content" }, [
              _c("div", { staticClass: "content" }, [
                _c("p", [_c("strong", [_vm._v("Accept This Task")]), _c("br")])
              ])
            ])
          ]),
          _c("isButton", {
            ref: "btnConfirmTask",
            attrs: {
              slot: "action",
              onClick: _vm.acceptTaskAction,
              state: "true",
              title: "PO&Production"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c(
        "modal",
        {
          attrs: { title: "Cancel Accept Task" },
          model: {
            value: _vm.openCancelTask,
            callback: function($$v) {
              _vm.openCancelTask = $$v
            },
            expression: "openCancelTask"
          }
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("strong", [_vm._v("If Cancel Accept Task")]),
            _c("br"),
            _vm._v("\n      Would you like to cancel task.\n    ")
          ]),
          _c(
            "button",
            {
              staticClass: "button is-success",
              attrs: { slot: "action" },
              on: {
                click: function($event) {
                  _vm.acceptTaskAction()
                }
              },
              slot: "action"
            },
            [_vm._v("OK")]
          )
        ]
      ),
      _c(
        "modal",
        {
          attrs: { title: "Cancel Project" },
          model: {
            value: _vm.openCancel,
            callback: function($$v) {
              _vm.openCancel = $$v
            },
            expression: "openCancel"
          }
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("div", { staticClass: "media-content" }, [
              _c("div", { staticClass: "content" }, [
                _c("div", [_vm._v("Would you like to cancel this project ?")]),
                _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.DeleteMessage,
                        expression: "DeleteMessage"
                      }
                    ],
                    staticClass: "input",
                    attrs: { type: "text", placeholder: "Remark" },
                    domProps: { value: _vm.DeleteMessage },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.DeleteMessage = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ])
          ]),
          _c("isButton", {
            ref: "btnCancel",
            attrs: {
              slot: "action",
              onClick: _vm.cancelProject,
              state: "true",
              title: "Confirm Cancel"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("h1", { staticClass: "title is-2" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.ProjectDetail.projectName) +
                "\n          "
            )
          ]),
          _c("p", { staticClass: "subtitle" }, [
            _vm._v(
              "\n             " +
                _vm._s(_vm.ProjectDetail.projectID) +
                "\n          "
            )
          ]),
          _c("div", { staticClass: "columns is-multiline" }, [
            _c("div", { staticClass: "column is-4" }, [
              _c("div", { staticClass: "is-pulled-left" }, [
                _c(
                  "span",
                  { class: _vm.createlbl(_vm.ProjectDetail.projectStatus) },
                  [_vm._v(_vm._s(_vm.ProjectDetail.projectStatus))]
                )
              ])
            ]),
            _c("div", { staticClass: "column is-8" }, [
              _c("div", { staticClass: "is-pulled-right" }, [
                _vm.ProjectDetail.projectStatus === "New" &&
                _vm.ProjectDetail.actKnowBy !== "" &&
                _vm.isAdmin()
                  ? _c("div", { staticClass: "column-button" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button is-warning",
                          attrs: {
                            href: "/project/edit/" + _vm.ProjectDetail.projectID
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-edit" }),
                          _vm._v(" Edit")
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm.ProjectDetail.projectStatus === "New" &&
                _vm.ProjectDetail.actKnowBy !== "" &&
                _vm.isAdmin()
                  ? _c("div", { staticClass: "column-button" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-info",
                          on: { click: _vm.showModelAccept }
                        },
                        [
                          _c("i", { staticClass: "fa fa-check-circle" }),
                          _vm._v("  Accept Job ")
                        ]
                      ),
                      _vm._v("  \n            ")
                    ])
                  : _vm._e(),
                _vm.ProjectDetail.projectStatus === "New" &&
                _vm.ProjectDetail.actKnowBy === "" &&
                _vm.isAdmin()
                  ? _c("div", { staticClass: "column-button" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-info",
                          on: { click: _vm.showModelConfirm }
                        },
                        [
                          _c("i", { staticClass: "fa fa-check" }),
                          _vm._v("  Acknowledge")
                        ]
                      ),
                      _vm._v("  \n            ")
                    ])
                  : _vm._e(),
                _vm.ProjectDetail.projectStatus === "Quoted" &&
                _vm.isAdmin() &&
                _vm.ProjectDetail.poName !== null
                  ? _c("div", { staticClass: "column-button" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-info",
                          on: { click: _vm.showModalAssign }
                        },
                        [
                          _c("i", { staticClass: "fa fa-list-ol" }),
                          _vm._v("  Assign Job #")
                        ]
                      ),
                      _vm._v("  \n            ")
                    ])
                  : _vm._e(),
                _vm.ProjectDetail.projectStatus === "Complete" && _vm.isAdmin()
                  ? _c("div", { staticClass: "column-button" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-info",
                          on: { click: _vm.showModalReminder }
                        },
                        [
                          _c("i", { staticClass: "fa fa-clock-o" }),
                          _vm._v("  Reminder")
                        ]
                      ),
                      _vm._v("  \n            ")
                    ])
                  : _vm._e(),
                _vm.ProjectDetail.projectStatus === "Working" && _vm.isAdmin()
                  ? _c("div", { staticClass: "column-button" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-success",
                          on: { click: _vm.showComplete }
                        },
                        [
                          _c("i", { staticClass: "fa fa-check" }),
                          _vm._v("  Complete")
                        ]
                      ),
                      _vm._v("  \n            ")
                    ])
                  : _vm._e(),
                _vm.isAdmin() &&
                _vm.ProjectDetail.actKnowBy !== "" &&
                _vm.ProjectDetail.projectStatus === "New"
                  ? _c("div", { staticClass: "column-button" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-danger",
                          on: { click: _vm.showDelete }
                        },
                        [
                          _c("i", { staticClass: "fa fa-check" }),
                          _vm._v("  Delete")
                        ]
                      ),
                      _vm._v("  \n            ")
                    ])
                  : _vm._e(),
                _vm.ProjectDetail.actKnowBy !== "" &&
                _vm.ProjectDetail.projectStatus !== "New" &&
                _vm.ProjectDetail.projectStatus !== "Complete" &&
                _vm.ProjectDetail.projectStatus !== "Delete" &&
                _vm.ProjectDetail.projectStatus !== "Cancel" &&
                _vm.userData.roleID === "SuperAdmin"
                  ? _c("div", { staticClass: "column-button" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-danger",
                          on: { click: _vm.showCancel }
                        },
                        [
                          _c("i", { staticClass: "fa fa-check" }),
                          _vm._v("  Cancel")
                        ]
                      ),
                      _vm._v("  \n            ")
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _c(
            "tabs",
            [
              _c("tab", { attrs: { name: "Overview", selected: true } }, [
                _vm._v("\n        " + _vm._s(_vm.filterIndex()) + "\n        "),
                _c(
                  "div",
                  {
                    staticClass: "wizard wizard-wired",
                    staticStyle: { width: "100%" },
                    attrs: {
                      id: "WiredWizard",
                      "data-target": "#WiredWizardsteps"
                    }
                  },
                  [
                    _c(
                      "ul",
                      { staticClass: "steps" },
                      _vm._l(_vm.statusDatas, function(item, index) {
                        return _c(
                          "li",
                          {
                            key: item,
                            class: _vm.activeBullet(index),
                            attrs: { "data-target": "#1" }
                          },
                          [
                            _c("span", { staticClass: "step" }, [
                              _c("span", {
                                class: _vm.createlblSpecial(item, index)
                              })
                            ]),
                            _c("span", { staticClass: "title" }, [
                              _c(
                                "span",
                                { class: _vm.createlblStep(item, index) },
                                [_vm._v(_vm._s(item))]
                              ),
                              _c("span", { staticClass: "projectDate" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("Date")(
                                      _vm.getProjectStatusDate(item)
                                    )
                                  )
                                )
                              ])
                            ]),
                            _c("span", { staticClass: "chevron" })
                          ]
                        )
                      })
                    )
                  ]
                ),
                _c("div", { staticClass: "columns is-desktop" }, [
                  _c(
                    "div",
                    { staticClass: "column  is-7" },
                    [
                      _c("prodDetail", {
                        attrs: { ProjectDetail: _vm.ProjectDetail }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _c(
                        "div",
                        [
                          _c("chat-full", {
                            attrs: {
                              persons: _vm.personInChat,
                              datas: _vm.messages,
                              roomName: _vm.ProjectDetail.projectID,
                              title: "Chat With Customer",
                              cls: "is-link"
                            }
                          })
                        ],
                        1
                      ),
                      _c("br"),
                      _c(
                        "h3",
                        {
                          staticClass: "title is-4 is-spaced bd-anchor-title",
                          attrs: { id: "starter-template" }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "bd-anchor-link",
                              attrs: { href: "" }
                            },
                            [_vm._v("\n                #\n              ")]
                          ),
                          _c("span", { staticClass: "bd-anchor-name" }, [
                            _vm._v(
                              "\n                Team member\n              "
                            )
                          ])
                        ]
                      ),
                      _c("hr"),
                      _c("componentRelatedUser", {
                        attrs: { small: "Yes", data: _vm.allPersonInProject }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm.ProjectDetail.projectStatus != "Delete"
                ? _c("tab", { attrs: { name: "Partner", selected: false } }, [
                    _c("div", { staticClass: "columns" }, [
                      _c("div", { staticClass: "column " }, [
                        _c(
                          "article",
                          { staticClass: "box-section" },
                          [
                            _c(
                              "div",
                              { staticClass: "message-section is-clearfix" },
                              [
                                _c("p", [_vm._v("Production Detail")]),
                                _vm.canOpenTask(_vm.ProjectDetail.projectStatus)
                                  ? [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "is-warning",
                                          attrs: {
                                            href: _vm.createUrlTask(
                                              _vm.ProjectDetail.projectID
                                            )
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-tasks"
                                          }),
                                          _vm._v("  Create Task")
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._l(_vm.groupVendor, function(vendor, index) {
                              return _c("div", { key: index }, [
                                _c("h2", { staticClass: "title is-5" }, [
                                  _vm._v(_vm._s(vendor.vendorName))
                                ]),
                                _c(
                                  "table",
                                  { staticClass: "table is-striped" },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticClass: "c1",
                                            attrs: { width: "15%" }
                                          },
                                          [_vm._v("TaskID")]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "c2",
                                            attrs: { width: "15%" }
                                          },
                                          [_vm._v("TaskName")]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "c3",
                                            attrs: { width: "5%" }
                                          },
                                          [_vm._v("Status")]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "c3",
                                            attrs: { width: "5%" }
                                          },
                                          [_vm._v("ReqLeadTime")]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "c3",
                                            attrs: { width: "10%" }
                                          },
                                          [_vm._v("LeadTime")]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "c4",
                                            attrs: { width: "15%" }
                                          },
                                          [_vm._v("Est StartDate")]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "c4",
                                            attrs: { width: "15%" }
                                          },
                                          [_vm._v("Est FinishDate")]
                                        ),
                                        _vm.isAdmin()
                                          ? _c(
                                              "th",
                                              {
                                                staticStyle: {
                                                  "min-width": "300px"
                                                }
                                              },
                                              [_vm._v("Action")]
                                            )
                                          : _vm._e()
                                      ])
                                    ]),
                                    _c(
                                      "tbody",
                                      _vm._l(vendor.tasks, function(
                                        task,
                                        index2
                                      ) {
                                        return _c("tr", { key: index2 }, [
                                          _c(
                                            "td",
                                            [
                                              _c(
                                                "nuxt-link",
                                                {
                                                  staticClass: "is-link",
                                                  attrs: {
                                                    to:
                                                      "/project/tasks/view/" +
                                                      task.prodTaskID
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(task.prodTaskID)
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c("td", [
                                            _vm._v(_vm._s(task.prodTaskName))
                                          ]),
                                          _c(
                                            "td",
                                            { attrs: { align: "center" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  class:
                                                    "is-lbl is-status-" +
                                                    task.prodTaskStatus.replace(
                                                      "&",
                                                      ""
                                                    )
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(task.prodTaskStatus)
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "td",
                                            { attrs: { align: "right" } },
                                            [_vm._v(_vm._s(task.reqLeadTime))]
                                          ),
                                          _c(
                                            "td",
                                            { attrs: { align: "right" } },
                                            [_vm._v(_vm._s(task.leadTime))]
                                          ),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("Date")(
                                                  task.estStartDate
                                                )
                                              )
                                            )
                                          ]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("Date")(
                                                  task.estFinishDate
                                                )
                                              )
                                            )
                                          ]),
                                          _vm.isAdmin()
                                            ? _c("td", [
                                                task.prodTaskStatus == "New"
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "button  is-small is-warning",
                                                        attrs: {
                                                          href:
                                                            "/project/tasks/edit/" +
                                                            task.prodTaskID
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-edit"
                                                        }),
                                                        _vm._v("  Edit")
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                task.quName !== ""
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "button  is-small is-info",
                                                        attrs: {
                                                          target: "_blank",
                                                          href:
                                                            "http://api.musubi-thai.com/public/" +
                                                            task.quPath +
                                                            task.quSaveName,
                                                          title:
                                                            "download quotaion"
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-download fa-lg"
                                                        }),
                                                        _vm._v("  Download")
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(
                                                  "\n                       \n                      "
                                                ),
                                                task.prodTaskStatus === "Accept"
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "button  is-small is-success",
                                                        attrs: {
                                                          href: "#",
                                                          title: "confirm task"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.openAcceptTaskModal(
                                                              task.prodTaskID,
                                                              $event
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-check-circle-o fa-lg"
                                                        }),
                                                        _vm._v(
                                                          "  PO&Production"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ])
                                            : _vm._e()
                                        ])
                                      })
                                    )
                                  ]
                                )
                              ])
                            })
                          ],
                          2
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.isAdmin()
                ? _c("tab", { attrs: { name: "Quotation", selected: false } }, [
                    _c("div", { staticClass: "columns" }, [
                      _c("div", { staticClass: "column" }, [
                        _vm.isAdmin() &&
                        (_vm.ProductionTask != null &&
                          _vm.ProductionTask.length > 0)
                          ? _c("article", { staticClass: "box-section" }, [
                              _c(
                                "div",
                                { staticClass: "message-section is-clearfix" },
                                [
                                  _c("p", [_vm._v("Previous Quotation")]),
                                  _vm.ProjectDetail.projectStatus == "Quoting"
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "is-warning",
                                            attrs: {
                                              href: _vm.createUrlQU(
                                                _vm.projectID
                                              ),
                                              "aria-label": "edit"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-check"
                                            }),
                                            _vm._v("  Create New Quoation")
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm.listQU.length > 0
                                ? _c(
                                    "div",
                                    { staticStyle: { "margin-top": "10px" } },
                                    [
                                      _c(
                                        "table",
                                        { staticClass: "table cleantable" },
                                        [
                                          _c("thead", [
                                            _c("tr", [
                                              _c("th", [_vm._v("Quoation No")]),
                                              _c("th", [_vm._v("Status")]),
                                              _c("th", [_vm._v("Revise")]),
                                              _c("th", [_vm._v("Create Date")]),
                                              _c("th", [_vm._v("LeadTime")]),
                                              _c("th", [_vm._v("Amount")]),
                                              _c("th")
                                            ])
                                          ]),
                                          _c(
                                            "tbody",
                                            _vm._l(_vm.listQU, function(
                                              item,
                                              index
                                            ) {
                                              return _c("tr", { key: index }, [
                                                _c("td", [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "/project/quotation/?quNo=" +
                                                          item.quNo +
                                                          "&revise=" +
                                                          item.revise +
                                                          "&projectID=" +
                                                          item.projectID
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(item.quNo))]
                                                  )
                                                ]),
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: { align: "center" }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        class:
                                                          "lbl lbl-status-" +
                                                          item.quStatus
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.quStatus)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c("td", [
                                                  _vm._v(_vm._s(item.revise))
                                                ]),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("DateTime")(
                                                        item.createOn
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("Number")(
                                                        item.leadTime
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("Currency")(
                                                        item.amount
                                                      )
                                                    )
                                                  )
                                                ]),
                                                _c("td", [
                                                  _vm.ProjectDetail
                                                    .projectStatus == "New" ||
                                                  _vm.ProjectDetail
                                                    .projectStatus == "Quoting"
                                                    ? _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "button is-small is-info",
                                                          staticStyle: {
                                                            "margin-right":
                                                              "5px"
                                                          },
                                                          attrs: {
                                                            href: _vm.createUrlRevise(
                                                              item.quNo,
                                                              item.projectID,
                                                              item.revise
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-edit"
                                                          }),
                                                          _vm._v("  Revise")
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.ProjectDetail
                                                    .projectStatus == "New" ||
                                                  _vm.ProjectDetail
                                                    .projectStatus == "Quoting"
                                                    ? _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "button is-small is-success",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.showAcceptQU(
                                                                item.quNo,
                                                                item.revise
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-check-circle-o"
                                                          }),
                                                          _vm._v("  Accept")
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ])
                                              ])
                                            })
                                          )
                                        ]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "button is-success",
                                          on: { click: _vm.showResetQuoation }
                                        },
                                        [_vm._v("Reset Quotation")]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        this.$store.state.authUser.roleID === "Customer" &&
                        _vm.listQU.length > 0
                          ? _c("article", { staticClass: "box-section" }, [
                              _c(
                                "div",
                                { staticClass: "message-section is-clearfix" },
                                [_c("p", [_vm._v("Previous Quotation")])]
                              ),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "10px" } },
                                [
                                  _c(
                                    "table",
                                    { staticClass: "table cleantable" },
                                    [
                                      _c("thead", [
                                        _c("tr", [
                                          _c("th", [_vm._v("Quoation No")]),
                                          _c("th", [_vm._v("Status")]),
                                          _c("th", [_vm._v("Revise")]),
                                          _c("th", [_vm._v("Create Date")]),
                                          _c("th", [_vm._v("LeadTime")]),
                                          _c("th", [_vm._v("Amount")]),
                                          _c("th")
                                        ])
                                      ]),
                                      _c(
                                        "tbody",
                                        _vm._l(_vm.listQU, function(
                                          item,
                                          index
                                        ) {
                                          return _c("tr", { key: index }, [
                                            _c("td", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: _vm.CreateUrlQUDetail(
                                                      item.quNo,
                                                      item.revise,
                                                      _vm.projectID
                                                    )
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.quNo))]
                                              )
                                            ]),
                                            _c(
                                              "td",
                                              { attrs: { align: "center" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class:
                                                      "lbl lbl-status-" +
                                                      item.quStatus
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.quStatus)
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c("td", [
                                              _vm._v(
                                                "Version " +
                                                  _vm._s(item.revise + 1)
                                              )
                                            ]),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("DateTime")(
                                                    item.createOn
                                                  )
                                                )
                                              )
                                            ]),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("Number")(
                                                    item.leadTime
                                                  )
                                                )
                                              )
                                            ]),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("Currency")(
                                                    item.amount
                                                  )
                                                )
                                              )
                                            ]),
                                            _c("td", [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "button is-small is-success",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.acceptQU(
                                                        item.quNo,
                                                        item.revise
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa fa-check"
                                                  }),
                                                  _vm._v("  Accept")
                                                ]
                                              )
                                            ])
                                          ])
                                        })
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ])
                : _vm._e(),
              _c("tab", { attrs: { name: "Work process", selected: false } }, [
                _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "column" }, [
                    _vm.lastQU !== null && _vm.lastQU.quotationTask.length > 0
                      ? _c(
                          "article",
                          { staticClass: "box-section" },
                          [
                            _c(
                              "div",
                              { staticClass: "message-section is-clearfix" },
                              [
                                _c("p", [_vm._v("Latest Quotation")]),
                                _vm.isAdmin()
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "is-warning",
                                        attrs: { "aria-label": "edit" },
                                        on: {
                                          click: function($event) {
                                            _vm.showActual($event)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", { staticClass: "fa fa-check" }),
                                        _vm._v("  Set Actual Date")
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _c("div", { staticClass: "content" }, [
                              _c(
                                "h2",
                                {
                                  staticClass: "title",
                                  staticStyle: { "margin-bottom": "0.5rem" }
                                },
                                [_vm._v(_vm._s(_vm.lastQU.quNo))]
                              ),
                              _c(
                                "span",
                                {
                                  class: _vm.createQUStatus(_vm.lastQU.quStatus)
                                },
                                [_vm._v(_vm._s(_vm.lastQU.quStatus))]
                              ),
                              _c("br"),
                              _c("br")
                            ]),
                            _c("grantchartQU", {
                              attrs: {
                                tasks: _vm.lastQU.quotationTask,
                                isShowActual: "Yes"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]),
                _vm.lastQU !== null && _vm.lastQU.actualLog.length > 0
                  ? _c("div", { staticClass: "columns" }, [
                      _c("div", { staticClass: "column" }, [
                        _c("h3", [
                          _c("b", [
                            _c("i", { staticClass: "fa fa-bookmark" }),
                            _vm._v(" Actual Log")
                          ])
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm.lastQU !== null && _vm.lastQU.actualLog.length > 0
                  ? _c("div", { staticClass: "columns" }, [
                      _c("div", { staticClass: "column" }, [
                        _c("table", { staticClass: "table" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v("#")]),
                              _c("th", [_vm._v("ActionOn")]),
                              _c("th", [_vm._v("ActionBy")]),
                              _c("th", [_vm._v("ActionRemark")])
                            ])
                          ]),
                          _c(
                            "tbody",
                            _vm._l(_vm.lastQU.actualLog, function(item, index) {
                              return _c("tr", { key: item.id }, [
                                _c("td", [_vm._v(_vm._s(index + 1))]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm._f("DateTime")(item.createOn))
                                  )
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(item.createBy) +
                                      " : " +
                                      _vm._s(item.createByName)
                                  )
                                ]),
                                _c("td", [_vm._v(_vm._s(item.updateRemark))])
                              ])
                            })
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm.ProjectDetail.projectStatus === "Quoted" ||
              _vm.ProjectDetail.projectStatus === "Complete" ||
              _vm.ProjectDetail.projectStatus === "Working"
                ? _c("tab", { attrs: { name: "PO", selected: false } }, [
                    _vm.ProjectDetail.poName !== "" &&
                    _vm.ProjectDetail.poName !== null
                      ? _c("div", { staticClass: "columns" }, [
                          _c("div", { staticClass: "column" }, [
                            _c("h3", { staticClass: "title" }, [
                              _vm._v("PO File")
                            ]),
                            _vm._v("\n            Download PO "),
                            _c("i", { staticClass: "fa fa-download" }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  target: "_blank",
                                  href:
                                    "https://api.musubi-thai.com/public/" +
                                    _vm.ProjectDetail.poPath +
                                    _vm.ProjectDetail.poName
                                }
                              },
                              [_vm._v(_vm._s(_vm.ProjectDetail.poOrgName))]
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _c("tab", { attrs: { name: "Project files", selected: false } }, [
                _vm.isViewFile()
                  ? _c("div", { staticClass: "columns" }, [
                      _c(
                        "div",
                        { staticClass: "column" },
                        [
                          _c("componentRelatedFile", {
                            attrs: { data: _vm.projectFiles }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ]),
              _c("tab", { attrs: { name: "Team member", selected: false } }, [
                _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "column" }, [
                    _vm.ProjectDetail.projectStatus != "Delete"
                      ? _c(
                          "article",
                          { staticClass: "box-section" },
                          [
                            _c(
                              "div",
                              { staticClass: "message-section is-clearfix" },
                              [
                                _c("p", [_vm._v("Contact")]),
                                _vm.isAdmin()
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "is-primary",
                                        on: { click: _vm.showEngineers }
                                      },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v("  Assign Team member")
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _c("componentRelatedUser", {
                              attrs: { data: _vm.allPersonInProject }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6a1384a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6a1384a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/_id.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d6a1384a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/_id.vue
// module chunks = 0